export const DRILLDOWN_METRICS = {
  conversations_handled: 'CAPTAIN.OVERVIEW.V2.DRILLDOWN.HANDLED',
  auto_resolution_rate: 'CAPTAIN.OVERVIEW.V2.DRILLDOWN.RESOLVED',
  handoff_rate: 'CAPTAIN.OVERVIEW.V2.DRILLDOWN.HANDED_OFF',
  reopen_rate: 'CAPTAIN.OVERVIEW.V2.DRILLDOWN.REOPENED',
  durable_resolution_rate: 'CAPTAIN.OVERVIEW.V2.DRILLDOWN.DURABLE',
  closed_with_team: 'CAPTAIN.OVERVIEW.V2.DRILLDOWN.CLOSED_WITH_TEAM',
  reopened_within_7_days:
    'CAPTAIN.OVERVIEW.V2.DRILLDOWN.REOPENED_WITHIN_7_DAYS',
  stayed_closed: 'CAPTAIN.OVERVIEW.V2.DRILLDOWN.STAYED_CLOSED',
  handoff_reason: 'CAPTAIN.OVERVIEW.V2.DRILLDOWN.HANDOFF_REASON',
};
